import { sharedDictionaryRu } from 'i18n/ru/sharedDictionaryRu';
import { GiroPaymentManagerDictionary } from 'types/i18n';

export const giroPaymentManagerDictionaryRu: GiroPaymentManagerDictionary = {
  summaryScreen: {
    titleText(giroPaymentId) {
      return `Платеж №${giroPaymentId}`;
    },

    detailsTable: {
      titleText: 'Описание',

      recievedAtLabel: 'Дата поступления',
      recievedAmountLabel: 'Поступило',
      creditedAmountLabel: 'На баланс',
      exchangeRateLabel: 'Курс обмена',
      statusLabel: 'Статус',
      updatedAtLabel: 'Обновление',
      createdAtLabel: 'Дата создания',
      idLabel: 'ID платежа',

      editRateText: 'Изменить курс',
    },

    clientTable: {
      titleText: 'Клиент',

      organizationLabel: 'Организация',
      fullNameLabel: 'ФИО',
      unpLabel: 'УНП (ИНН / TIN)',
      clientIdLabel: 'ID клиента',
      residentLabel: 'Резидент РБ',
      balanceLabel: 'Баланс',
      debitsLabel: 'Списания',
      residentValue(resident) {
        if (resident) {
          return 'Да';
        }

        return 'Нет';
      },
      billPrimaryAmountText(m8DebitDTO) {
        return sharedDictionaryRu.moneyAmountText(m8DebitDTO.amount, 'USD');
      },
      billSecondaryAmountText(m8DebitDTO) {
        if (!m8DebitDTO.user.resident) {
          const eurPart = m8DebitDTO.eurAmount
            ? sharedDictionaryRu.moneyAmountText(m8DebitDTO.eurAmount, 'EUR')
            : null;

          const rubPart = m8DebitDTO.rubAmount
            ? sharedDictionaryRu.moneyAmountText(m8DebitDTO.rubAmount, 'RUB')
            : null;

          return `(${eurPart} / ${rubPart})`;
        }

        return '';
      },
    },

    paymentTable: {
      titleText: 'Платежка',

      bankAccountNameLabel: 'Плательщик',
      bankAccountUnpLabel: 'УНП (ИНН / TIN)',
      bankAccountIdLabel: 'Номер счета',
      commentLabel: 'Примечание',
    },

    searchClientButtonText: 'Найти клиента',
    editClientButtonText: 'Изменить клиента',
    cancelPaymentButtonText: 'Ошибочный платеж',
    confirmPaymentButtonText: 'Зачислить деньги на счет',
  },

  clientSearchScreen: {
    titleText: 'Поиск клиента',

    clientTable: {
      titleText: 'Клиент',

      changeActionText: 'Изменить',

      organizationNameLabel: 'Организация',
      fullNameLabel: 'ФИО',
      idLabel: 'ID клиента',
      prodStackLabel: 'Приложение',
      unpLabel: 'УНП (ИНН / TIN)',
    },
    submitActionText: 'Привязать платеж',
    cancelActionText: 'Отмена',
  },

  rateEditorScreen: {
    titleText: 'Изменить курс обмена',

    dateLabelText: 'Курс на дату',

    rateLabelText(m8RateDTO) {
      const amountText = sharedDictionaryRu.moneyAmountText(
        1,
        m8RateDTO.currency
      );

      return `Курс за ${amountText}`;
    },

    rateValueText(m8RateDTO) {
      return sharedDictionaryRu.moneyAmountText(m8RateDTO.value, 'BYN');
    },

    submitActionText: 'Изменить',
    cancelActionText: 'Отмена',
  },
};
